import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient';
import { HttpClient } from 'core/infra/http/HttpClient';
import { BASE_API_URL } from 'core/infra/environment';
import { TOKEN_STORAGE_USER_KEY } from 'auth/domain/User';

export const signOut = async () => {
  const storage = new LocalStorageClient();
  const token = storage.get<string>(TOKEN_STORAGE_USER_KEY);
  
  // Call backend logout endpoint if token exists
  if (token) {
    try {
      const httpClient = new HttpClient(BASE_API_URL);
      await httpClient.post('/logout', {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
    } catch (error) {
      // Log error but don't break the logout flow
      console.error('Failed to call logout endpoint:', error);
    }
  }
  
  // Always clear local storage regardless of API call success/failure
  storage.clear();
};
